const DEFAULT_API_BASE_URLS = {
  development: "http://localhost:8081/trippin/",
  production: "https://server.jonytis.eu:443/trippin/",
} as const;

function ensureTrailingSlash(value: string): string {
  return value.endsWith("/") ? value : `${value}/`;
}

export function getApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL?.trim();
  if (configured) return ensureTrailingSlash(configured);

  return import.meta.env.DEV ? DEFAULT_API_BASE_URLS.development : DEFAULT_API_BASE_URLS.production;
}
